import axios, { AxiosInstance } from "axios";
import { requestInterceptor, responseErrorInterceptor } from "../interceptors";

export const apiWithoutAuth: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOME_BFF,
  headers: {
    "Accept-Version": "v1",
  },
});

apiWithoutAuth.interceptors.response.use(null, responseErrorInterceptor);

export const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOME_BFF,
  headers: {
    "Accept-Version": "v1",
  },
});

api.interceptors.request.use(requestInterceptor);
api.interceptors.response.use(null, responseErrorInterceptor);

export async function getCurrentCustomer() {
  return api
    .post(null, {
      query: `
        query GetCurrentCustomer {
          getCurrentCustomer {
            ... on Customer {
              id
              contactCellphone
              contactCellphoneCode
              cpf
              email
              fullName
            }
          }
        }
    `,
    })
    .then((response) => {
      return {
        customerId: response.data.data?.getCurrentCustomer?.id,
        fullName: response.data.data?.getCurrentCustomer?.fullName,
        contactCellphone:
          response.data.data?.getCurrentCustomer?.contactCellphone,
        contactCellphoneCode:
          response.data.data?.getCurrentCustomer?.contactCellphoneCode,
        cpf: response.data.data?.getCurrentCustomer?.cpf,
        email: response.data.data?.getCurrentCustomer?.email,
      };
    });
}

export async function getLead(customerId) {
  return api
    .post(null, {
      query: `
        query GetLead ($customerId: String!) {
          getLead (customerId: $customerId) {
            ... on Lead {
              active
              activenessDescription
            }
          }
        }
    `,
      variables: { customerId },
    })
    .then((response) => {
      return {
        isActive: response.data.data?.getLead?.active ?? false,
        description: response.data.data?.getLead?.activenessDescription,
      };
    });
}

export async function authenticateWithRefreshToken(refreshToken: string) {
  return apiWithoutAuth
    .post(null, {
      query: `
        mutation GetNewUserTokenByRefreshToken($params: GetNewUserTokenByRefreshTokenPayload!) {
          getNewUserTokenByRefreshToken(params: $params) {
            accessToken
            expiresIn
            refreshToken
            legacyAccessToken
          }
        }
      `,
      variables: {
        params: {
          data: {
            grantType: "refresh_token",
            refreshToken,
          },
        },
      },
    })
    .then((response) => {
      return {
        ...response?.data?.data?.getNewUserTokenByRefreshToken,
      };
    });
}
